import { Outlet } from 'react-router';
import { Box, Grid } from "@mui/material";

import { AuthLayoutBackground } from './AuthLayoutBackground';
import { AuthLayoutFooter } from './AuthLayoutFooter';
import { Logo } from '~/assets/Logo';
import { MainCard } from '~/components/MainCard';

export const AuthLayout = () =>
    <Box sx={{ minHeight: '100vh' }}>
        <AuthLayoutBackground />
        <Grid
            container
            direction={'column'}
            justifyContent={'center'}
            sx={{ minHeight: '100vh' }}
        >
            <Grid size={12} sx={{ pl: 3, pt: 3 }}>
                <Logo />
            </Grid>
            <Grid size={12}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    sx={{
                        minHeight: {
                            xs: 'calc(100vh - 210px)',
                            sm: 'calc(100vh - 134px)',
                            md: 'calc(100vh - 120px)',
                        },
                    }}
                >
                    <Grid>
                        <MainCard
                            sx={{
                                maxWidth: { xs: 400, lg: 475 },
                                margin: { xs: 2.5, md: 3 },
                                '& > *': { flexGrow: 1, flexBasis: '50%' },
                            }}
                            content={false}
                            border={false}
                            boxShadow
                        >
                            <Box sx={{ p: { xs: 2, sm: 3, md: 4, xl: 5 } }}>
                                <Outlet />
                            </Box>
                        </MainCard>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12} sx={{ p: 3, pt: 1 }}>
                <AuthLayoutFooter />
            </Grid>
        </Grid>
    </Box>;
